export enum ECheckoutType {
  PICPAY = '72',
  PIX = '125',
  CARTAO = '1',
  CASH = '47',
}

export enum EOrdersType {
  SELECTPAYMENT = 'selectPayment',
  CLOSEORDER = 'closeOrder',
  CHECKPAYMENTSTATUS = 'checkPaymentStatus',
}

export enum EFlagCreditCard {
  ELO = 'Elo',
  VISA = 'Visa',
  MASTERCARD = 'Mastercard',
  AMERICAN_EXPRESS = 'American Express',
}
